const dataLayer = {
  booking: {
    step4: (data) => {
      if (!data) {
        return false
      }

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'rac transactionvalue': data.toString(),
      })
    },
  },
}

export default dataLayer
